

(function(window, jQuery) {
  var $window = jQuery(window);

  $window.on('load', function() {
    var popovers = jQuery('[data-toggle="popover"]');

    if (popovers.length) {
      popovers.popover();
    }
  });
})(window, jQuery);

